<template>

  <div>
    <b-overlay :show="overlay">
      <b-card no-body class="mb-0">
        <div class="m-2">
          <!-- Table Top -->
          <b-row>
            <!-- Per Page -->
            <b-col cols="12" md="6" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
              <label>Mostrar</label>
              <v-select v-model="perPage" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :options="perPageOptions"
                :clearable="false" class="per-page-selector d-inline-block mx-50" />
              <label>entradas</label>
            </b-col>

            <b-col cols="12" md="6">
              <div class="d-flex align-items-center justify-content-end actions-wrapper">
                <b-input-group>
                  <b-form-input
                      v-model="searchInputValue"
                      class="d-inline-block"
                      placeholder="Pesquisar por código de representante ou condição..."
                      @keyup.enter="handleSearch"
                  />
                  <b-input-group-append>
                    <b-button :disabled="overlay" @click="clearSearch" variant="outline-danger">
                      <feather-icon icon="TrashIcon"/>
                    </b-button>
                    <b-button :disabled="overlay" @click="handleSearch" variant="outline-primary">
                      <feather-icon icon="SearchIcon"/>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
                <b-button variant="primary" @click="openAddModal">
                  <div class="d-flex" style="gap: 5px">
                    <iconfy icon="mdi:plus" />
                    <span class="">Representante X Cond. Pgto</span>
                  </div>
                </b-button>
              </div>
            </b-col>
          </b-row>

        </div>

        <b-table ref="refRepresCondPagtoListTable" class="position-relative" :items="fetchRepresCondPagto" responsive
          :fields="tableColumns" primary-key="id" :sort-by.sync="sortBy" show-empty
          empty-text="Nenhum registro encontrado" :sort-desc.sync="isSortDirDesc">
          <template #cell(representante)="data">
            {{ data.item.representante.representanteid }} - {{ data.item.representante.representantenome }}
          </template>
          <template #cell(condicaopagamento)="data">
            {{ data.item.condicaopagamento.condicaopagamentoid }} - {{ data.item.condicaopagamento.condicaopagamentodescricao }}
          </template>
          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <div>
              <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" title="Visualizar" variant="gradient-primary" class="btn-icon mr-1"
                @click="openEditModal(data.item)">
                <feather-icon icon="EyeIcon" />
              </b-button>

              <b-button variant="gradient-danger" title="Deletar" class="btn-icon"  @click="openModalDeleteCustomField(data.item)">
                <feather-icon icon="TrashIcon" />
              </b-button>
            </div>

          </template>

        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start">
              <span class="text-muted">Mostrando {{ dataMeta.from }} até {{ dataMeta.to }} de {{
                dataMeta.of
              }} entradas</span>
            </b-col>
            <!-- Pagination -->
            <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">
              <b-pagination v-model="currentPage" :total-rows="totalRepresCondPagto" :per-page="perPage" first-number
                last-number class="mb-0 mt-1 mt-sm-0" prev-class="prev-item" next-class="next-item">
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </b-overlay>

    <ModalAdd idModal="modal-add-repres-cond-pagto" titleModal="Adicionar Representante X Condicao Pagamento"
      labelBtnOk="Adicionar" v-model="dataRepresCondPagto" @ok="create($event)" @cancel="resetFormData()" />
    <ModalAtt idModal="modal-att-repres-cond-pagto" titleModal="Atualizar Representante X Condicao Pagamento"
      labelBtnOk="Atualizar" v-model="dataRepresCondPagto" @ok="Updated($event)" @cancel="resetFormData()" />

    <modal-confirmation v-model="isDeleteModal" id-modal="modal-delete-repres-cond-pagto"
      title="Deletar Representante X Condicao Pagamento" btn-cancel-label="Cancelar" btn-ok-label="Sim, deletar"
      @ok="handleRemover(deletedCustomField.representanteid)" @cancel="resetFormData()">
      <template #message>
        <div>
          <p>Tem certeza que deseja deletar essa Representante X Condicao Pagamento?</p>
        </div>
      </template>
    </modal-confirmation>

  </div>
</template>

<script>
import { ref } from '@vue/composition-api';
import {
  BButton,
  BCard,
  BCardBody,
  BCardImg,
  BCardSubTitle,
  BCardText,
  BCardTitle,
  BCol,
  BRow,
  BListGroup,
  BListGroupItem,
  BTable,
  VBToggle,
  VBModal,
  BMedia,
  BLink,
  BAvatar,
  VBTooltip,
} from 'bootstrap-vue';
import { avatarText } from '@core/utils/filter';
import ModalConfirmation from '@/components/ModalConfirmation.vue';
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue';
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue';
import ModalAdd from '@/views/cadastros/apoio-vendas/repres-cond-pagto/list/ModalAdd.vue';
import ModalAtt from '@/views/cadastros/apoio-vendas/repres-cond-pagto/list/ModalAtt.vue';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import useList from './useList';

export default {
  components: {
    ModalAdd,
    ModalAtt,
    BAvatar,
    BLink,
    BMedia,
    ModalConfirmation,
    BButton,
    BCard,
    BCardBody,
    BCardImg,
    BCardSubTitle,
    BCardText,
    BCardTitle,
    BCol,
    BRow,
    AppCollapse,
    AppCollapseItem,
    BListGroup,
    BListGroupItem,
    BTable,
  },
  directives: {
    'b-toggle': VBToggle,
    'b-modal': VBModal,
    'b-tooltip': VBTooltip,
  },
  data() {
    return {
      isDeleteModal: false,
      deletedCustomField: {
        representanteid: null,
        condicaopagamentoid: '',
      },
      searchInputValue: '',
    };
  },
  methods: {
    handleRemover(id) {
      this.removerData(id);
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Sucesso',
          text: 'Representante X Condicao Pagamento deletado com sucesso',
          icon: 'CheckIcon',
          variant: 'success',
        },
      });
      this.isDeleteModal = false;
    },
    openModalDeleteCustomField(data) {
      this.deletedCustomField = data;
      this.isDeleteModal = true;
    },
    openEditModal(data) {
      this.dataRepresCondPagto = data;
      this.$bvModal.show('modal-att-repres-cond-pagto');
    },
    openAddModal() {
      this.resetFormData();
      this.$bvModal.show('modal-add-repres-cond-pagto');
    },
    resetFormData() {
      this.deletedCustomField = {
        representanteid: null,
        condicaopagamentoid: null,

      };
      this.dataRepresCondPagto = {
        representanteid: null,
        condicaopagamentoid: null,
      };
      this.isDeleteModal = false;
    },
    handleSearch() {
      this.searchQuery = this.searchInputValue;
    },
    clearSearch() {
      this.searchQuery = '';
      this.searchInputValue = '';
    },
  },
  setup() {
    const dataRepresCondPagto = ref({
      representanteid: null,
      condicaopagamentoid: null,
    });
    // 'VARCHAR', 'INTEGER', 'TIMESTAMP', 'BOOLEAN', 'DATETIME', 'DATE', 'ENUM_OPTIONS', 'TEXT'

    const currentTab = ref(0);
    const spanderAll = ref(false);

    const {
      perPage,
      currentPage,
      totalRepresCondPagto,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      tableColumns,
      refRepresCondPagtoListTable,
      fetchRepresCondPagto,
      overlay,
      resolveTypeFieldText,
      resolveTypeFieldIcon,
      resolveItemStatusVariant,
      resolverDefaultValues,
      create,
      Updated,
      removerData,
    } = useList();

    return {
      // Filter
      avatarText,
      spanderAll,
      currentTab,
      dataRepresCondPagto,
      resolveTypeFieldText,
      resolveTypeFieldIcon,
      resolveItemStatusVariant,
      resolverDefaultValues,
      perPage,
      currentPage,
      totalRepresCondPagto,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      fetchRepresCondPagto,
      overlay,
      tableColumns,
      refRepresCondPagtoListTable,
      Updated,
      create,
      removerData,
    };
  }
  ,
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.bg-header-collapse {
  background-color: #6c757d !important;
}

.actions-wrapper {
  gap: 0.5rem;
}

@media (max-width: 767.98px) {
  .actions-wrapper {
    flex-direction: column;
    align-items: stretch;
    gap: 0.75rem;
  }

  .actions-wrapper .input-group,
  .actions-wrapper .btn {
    width: 100%;
  }

  .actions-wrapper .btn {
    justify-content: center;
  }
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select';
</style>
